export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    additionalData: {
      type: Object
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  computed: {
    pageNumbers: function () {
      return Array.from(Array(Math.ceil(this.total / this.limit)).keys(), (x) => x + 1)
    },
    isLastPage: function () {
      return this.currentPage === this.pageNumbers.length
    },
    isFirstPage: function () {
      return this.currentPage === 1
    }
  },
  methods: {
    setPage: function (page) {
      this.currentPage = page
      this.$emit('pageChange', { page, additionalData: this.additionalData })
    },
    isActive: function (page) {
      return this.currentPage === page
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/pagination/pagination.js